import { render, staticRenderFns } from "./DrawerDemandsAndNeedsAdvised.vue?vue&type=template&id=4953daac&scoped=true&"
import script from "./DrawerDemandsAndNeedsAdvised.vue?vue&type=script&lang=js&"
export * from "./DrawerDemandsAndNeedsAdvised.vue?vue&type=script&lang=js&"
import style0 from "./DrawerDemandsAndNeedsAdvised.vue?vue&type=style&index=0&id=4953daac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4953daac",
  null
  
)

export default component.exports